const machine_txt = {
    type: "VA-W500D",
    name: "Smart Machines That Create Various New Values,Flatbed,Interlock Stitch Machine",
    description: [
        "Common Specifications",
        "Flatbed,interlock stitch machines",
        "Stitch length adjustment : Push-button",
        "Differential feed ratio adjustment:",
        "Lever that can be adjusted intermittently during sewing",
        "Maximum speed : 5,000 sti/min",
        "Lubrication : Fully-automatic",
        "Functional Characteristics",
        "New needle thread take-up mechanis,Super cost-effective'Sot/tieht seams' can be easily changed to 'tight/soft seams,' responding to a wide variely of sewn products made of extra light to heavy weight fabrics.",
        "Detachable looper thread take-up(optlonal)So it is easler to solve unexpected trouble.The installation position is reproduclble with no adjustments.",
        "User friendlyThis design focuses on the details required for safety, ease of operation and maintenance, viewed from the operator's standpoint.",
        "Super cost-effectlveSuperlor spare parts supply system and superlor versatility of spare parts make it more cost-effective, better close to the market and bring excellent products to end customers.",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/8/machine_img/1.jpg",
    ],
    machine_other_img:[
        "/assets/machine/8/machine_other/1.png",
        "/assets/machine/8/machine_other/2.png",
    ]
}
export default {machine_txt}